import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { ContactFormFields } from "./ContactFormFields";
// Prevent redundant rendering to avoid unexpected behavior with react-hook-form:
// This resolves the issue where entering an incorrect value in certain form fields
// causes arbitrary input fields to become unresponsive.
export const FormFieldsSection = memo(({ rootTestId, contactFormDatas }) => {
    return (_jsx(ContactFormFields, { contactFormDatas: contactFormDatas, contactFormRootTestId: rootTestId }));
});
FormFieldsSection.displayName = "FormFieldsSection";
